import {
  ACCEPT_OR_DECLINE_TERM,
  CLEAN_ACCEPTED_TERMS,
  CLIENT_TERMS_AND_CONDITIONS_FAILURE,
  CLIENT_TERMS_AND_CONDITIONS_REQUEST, CLIENT_TERMS_AND_CONDITIONS_SUCCESS, TermsAndConditionsModes
} from "../constants/ActionTypes";
import {CALL_API} from "../login/api.middleware";
import {CATALOG_SERVICE_URL} from "../constants/api";

export function fetchTheClientTermsAndConditions(clientId) {

  return {
    [CALL_API]: {
      endpoint: `${CATALOG_SERVICE_URL}/termsAndConditions`,
      params: {
        clientId,
        module: TermsAndConditionsModes.AFFILIATE,
      },
      types: [
          CLIENT_TERMS_AND_CONDITIONS_REQUEST,
          CLIENT_TERMS_AND_CONDITIONS_SUCCESS,
          CLIENT_TERMS_AND_CONDITIONS_FAILURE
      ],
      authenticated: true
    }
  };
}

export function acceptOrDeclineTerm(inputValue, termId) {

  return {
    type: ACCEPT_OR_DECLINE_TERM,
    inputValue,
    termId
  };
}


export function cleanTermsAndConditions(){
  return {
    type: CLEAN_ACCEPTED_TERMS
  }
}